"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";

export default function HomeSearch() {
  const router = useRouter();
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (query) {
      params.set("q", query);
    }
    if (category) {
      params.set("category", category);
    }
    const queryString = params.toString();
    router.push(queryString ? `/inventory?${queryString}` : "/inventory");
  };

  return (
    <div className="relative bg-gradient-to-br from-zinc-900 via-zinc-800 to-red-900 py-12 md:py-16 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-red-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-red-600 rounded-full blur-3xl"></div>
      </div>
      <div className="relative max-w-4xl mx-auto px-4 text-center">
        <Image
          src="/images/logo-getsmc-round-small.png"
          alt="Sur Motor Cars"
          width={64}
          height={64}
          className="mx-auto mb-4"
        />
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-3">
          Find Your Next Ride
        </h1>
        <p className="text-zinc-300 text-lg mb-8">
          Salvage &amp; rebuildable vehicles at unbeatable prices
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-2xl mx-auto">
          <div className="flex-1">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search by make, model, or keyword..."
              className="w-full px-5 py-4 bg-white border-0 rounded-xl text-lg shadow-lg focus:outline-none focus:ring-4 focus:ring-red-500/50"
            />
          </div>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="px-5 py-4 border-0 rounded-xl bg-white text-lg shadow-lg focus:outline-none focus:ring-4 focus:ring-red-500/50"
          >
            <option value="">All Types</option>
            <option value="car">Cars</option>
            <option value="truck">Trucks</option>
            <option value="suv">SUVs</option>
            <option value="other">Other</option>
          </select>
          <button
            type="submit"
            className="px-8 py-4 bg-red-600 hover:bg-red-500 text-white text-lg font-bold rounded-xl shadow-lg hover:shadow-red-500/25 transition-all flex items-center justify-center gap-2"
          >
            <i className="bootstrap-search"></i>
            Search
          </button>
        </form>
      </div>
    </div>
  );
}
